import { Component, OnInit, OnChanges } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, ActivatedRoute, Params } from "@angular/router";
import {MamMenuVerticalComponent} from "./mam_app_vertical.menu";
import {MamMenuComponent} from "./mam_app.menu";
import {CookieService} from "angular2-cookie/services/cookies.service";
import {TranslateServiceForm }   from "./translate";


@Component({
  selector: 'app-root',
  template:`
    <div [ngClass]="'page'">
      <div [ngClass]="'page-container'">
        <div [ngClass]="'page-content'" >
            <router-outlet (activate)="onActivate($event)" (deactivate)="onDeactivate($event)"></router-outlet>
        </div>
      </div>
    </div>
 `
})

export class MamAppComponent implements OnInit {
  username : string;
  

  constructor(private router: Router, private _translate: TranslateServiceForm, private cookie:CookieService, private activatedRoute: ActivatedRoute){
    this.setI18n();
  }

  ngOnInit() {
  
      this.activatedRoute.queryParams.subscribe(params => {
          var lang = params['lang'];
          if(lang) {
			if (this._translate.currentLang !== lang) {
				this._translate.use(lang);
				this.cookie.put('org.springframework.web.servlet.i18n.CookieLocaleResolver.LOCALE', lang);
				location.reload();
			}
          } 
      });
  }

  onActivate(event) {

  }

  onDeactivate(event) {

  }

  private setI18n () : void {
    var lang:string;
    if(this.cookie.get('org.springframework.web.servlet.i18n.CookieLocaleResolver.LOCALE')) {
      lang = this.cookie.get('org.springframework.web.servlet.i18n.CookieLocaleResolver.LOCALE');
      this._translate.use(lang);
    } else {
      this._translate.use(navigator.language);
      lang = this._translate.currentLang;
      this.cookie.put('org.springframework.web.servlet.i18n.CookieLocaleResolver.LOCALE', lang);
    }
  }
}

@NgModule({
  imports: [BrowserModule,HttpModule,FormsModule],
  exports: [MamAppComponent],
  declarations: [MamAppComponent],
  providers: [CookieService],

})
export class MamComponentModule{

}



// WEBPACK FOOTER //
// ./src/app/mam_app.component.ts